import { CategoryGroupInformation } from './api-services/individual-api/individual-api.types';
import { DEFAULT_SESSION_PERMISSIONS, SessionPermissionKey, SessionPermissions } from '../types/permissions';

interface PermissionRule {
  permission: SessionPermissionKey;
  category: string;
  group: string;
}

export const PERMISSION_GROUP_RULES: readonly PermissionRule[] = [
  {
    permission: 'nominate',
    category: 'FPC Nomination System - Permissions',
    group: 'Nominate',
  },
  {
    permission: 'approveOrReject',
    category: 'FPC Nomination System - NAR Site - Permissions',
    group: 'Approve - NAR',
  },
  {
    permission: 'viewOnly',
    category: 'FPC Nomination System - NAR Site - Permissions',
    group: 'View Only - NAR',
  },
] as const;

export function resolveSessionPermissions(memberships: readonly CategoryGroupInformation[]): SessionPermissions {
  const resolved: SessionPermissions = { ...DEFAULT_SESSION_PERMISSIONS };

  for (const rule of PERMISSION_GROUP_RULES) {
    resolved[rule.permission] = memberships.some((membership) => {
      const categoryName = normalizeText(membership.text);
      if (categoryName !== normalizeText(rule.category)) {
        return false;
      }

      const groups = membership.groups ?? [];
      return groups.some((group) => normalizeText(group.text) === normalizeText(rule.group));
    });
  }

  return resolved;
}

function normalizeText(value: string | null | undefined): string {
  return value?.trim().toLowerCase() ?? '';
}
